<template>
  <v-dialog v-model="dialog" max-width="640px" persistent scrollable>
    <v-card>
      <v-card-title
        ><div class="title--text">Đăng ký</div>
        <v-spacer />
        <v-icon class="mr-n1" @click="cancel()">mdi-close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4 pb-2">
        <v-form ref="form">
          <div class="text-subtitle-1 font-weight-medium mb-4">
            TÀI KHOẢN ĐĂNG KÝ TUYỂN SINH KHỐI 10
          </div>
          <div class="mb-4">
            <div class="text-subtitle-1">Họ và tên học sinh <span style="color: red">*</span></div>
            <v-text-field
              placeholder="VD: Nguyễn Văn A"
              name="login"
              color="primary"
              hint="Gõ tiếng Việt có dấu, đúng quy tắc viết hoa"
              persistent-hint
              v-model="studentName"
              :rules="[$rules.required, $rules.vietnameseName]"
              @keyup.enter="submit"
              outlined
            />
          </div>
          <div class="text-subtitle-1">Ngày tháng năm sinh <span style="color: red">*</span></div>
          <div class="mb-8">
            <DobSplitInput v-model="dob" ref="date-picker" />
          </div>
          <div class="mb-4">
            <div class="text-subtitle-1">Mã định danh cá nhân/Căn cước công dân <span style="color: red">*</span></div>
            <v-text-field
              placeholder="Nhập thông tin tại đây"
              name="login"
              color="primary"
              hint="Gồm 12 số theo giấy khai sinh hoặc theo Căn cước công dân do cơ quan công an cấp"
              persistent-hint
              v-mask="'############'"
              v-model="studentCode"
              @keyup.enter="submit"
              :rules="[$rules.required, $rules.minLengthBGD(12)]"
              outlined
            />
          </div>
          <div class="text-subtitle-1">
            Địa chỉ thường trú (Số nhà, Đường/Phố, Xã/Phường, Thành phố) <span style="color: red">*</span>
          </div>
          <v-text-field
            placeholder="VD: Số 17 Đường Hoàng Hoa Thám, Phường Ngô Quyền, Thành phố Hà Nội"
            name="login"
            color="primary"
            v-model="address"
            :rules="[$rules.required]"
            @keyup.enter="submit"
            outlined
          />
          <div class="text-subtitle-1">
            Thông tin trường đang học (Vui lòng chọn thông tin dưới đây) <span style="color: red">*</span>
          </div>
          <v-autocomplete
            :items="[...provinces, otherProvinceText]"
            v-model="selectedProvince"
            item-text="name"
            item-value="name"
            :menu-props="{maxHeight: 120}"
            outlined
            clearable
            :return-object="false"
            :rules="[$rules.required]"
            autocomplete="on"
            placeholder="Thành phố Hà Nội hoặc Tỉnh/Thành phố khác"
            :no-data-text="'Không tìm thấy Tỉnh/Thành phố phù hợp'"
          ></v-autocomplete>
          <v-text-field
            v-if="selectedProvince === otherProvinceText"
            v-model="otherProvince"
            outlined
            placeholder="Nhập tên Tỉnh/Thành phố tại đây"
            :rules="[v => selectedProvince !== otherProvinceText || !!v || 'Vui lòng nhập Tỉnh/Thành phố']"
          />

          <v-autocomplete
            v-if="selectedProvince !== otherProvinceText"
            :items="filteredWards"
            v-model="selectedWard"
            item-text="name"
            item-value="name"
            :menu-props="{maxHeight: 120}"
            outlined
            clearable
            :return-object="false"
            :rules="[$rules.required]"
            autocomplete="on"
            placeholder="Chọn Phường hoặc Xã"
            :no-data-text="'Không tìm thấy Phường/Xã phù hợp'"
          >
          </v-autocomplete>
          <v-text-field
            v-if="selectedProvince === otherProvinceText"
            v-model="otherWard"
            outlined
            placeholder="Nhập Phường/Xã tại đây"
            :rules="[v => !!v || 'Vui lòng nhập Phường/Xã']"
          />

          <v-autocomplete
            v-if="selectedProvince !== otherProvinceText"
            :items="[...filterSchools, {name: otherText, value: 'other'}]"
            v-model="studentSchool"
            item-text="name"
            item-value="name"
            :menu-props="{maxHeight: 120}"
            outlined
            clearable
            :return-object="false"
            :rules="[$rules.required]"
            autocomplete="on"
            placeholder="Chọn Tên trường"
            :no-data-text="'Không tìm thấy trường phù hợp'"
          ></v-autocomplete>
          <v-text-field
            v-if="studentSchool === otherText || selectedProvince === otherProvinceText"
            v-model="otherStudentSchool"
            outlined
            placeholder="Nhập tên trường tại đây"
            :rules="[v => studentSchool !== otherText || !!v || 'Vui lòng nhập tên trường']"
          ></v-text-field>

          <div class="text-subtitle-1">
            Nguyện vọng 1 trường cấp 3 <span style="color: red">*</span>
            <span style="color: #707070; font-size: 12px;"> (Dự kiến)</span>
          </div>

          <v-autocomplete
            :items="[...expectOptions, {name: otherText, value: 'other'}]"
            v-model="expectSchool"
            item-text="name"
            item-value="name"
            :menu-props="{maxHeight: 120}"
            outlined
            clearable
            :return-object="false"
            :rules="[$rules.required]"
            autocomplete="on"
            placeholder="Bắt đầu gõ để tìm kiếm..."
            :no-data-text="'Không tìm thấy trường phù hợp'"
          ></v-autocomplete>
          <v-text-field
            v-if="expectSchool === otherText"
            v-model="otherExpectSchool"
            outlined
            placeholder="Nhập tên trường tại đây"
            :rules="[v => expectSchool !== otherText || !!v || 'Vui lòng nhập tên trường']"
          ></v-text-field>
          <div>
            <div class="text-subtitle-1">Điểm trung bình môn Toán học kì 1 lớp 9<span style="color: red">*</span></div>

            <v-text-field
              placeholder="Nhập điểm tại đây"
              name="login"
              color="primary"
              v-model="mathScore"
              type="number"
              outlined
            />

            <div class="text-subtitle-1">
              Điểm trung bình môn Tiếng Anh học kì 1 lớp 9<span style="color: red">*</span>
            </div>

            <v-text-field
              placeholder="Nhập điểm tại đây"
              name="login"
              color="primary"
              v-model="englishScore"
              type="number"
              outlined
            />
          </div>
          <div class="mb-4">
            <div class="text-subtitle-1">Họ tên phụ huynh <span style="color: red">*</span></div>
            <v-text-field
              placeholder="Nhập tên phụ huynh tại đây"
              name="login"
              hint="Gõ tiếng Việt có dấu, đúng quy tắc viết hoa"
              persistent-hint
              color="primary"
              v-model="parentName"
              :rules="[$rules.required, $rules.vietnameseName]"
              outlined
            />
          </div>
          <div class="text-subtitle-1">
            Số điện thoại PH <span style="color: red">*</span>
          </div>
          <v-text-field
            placeholder="Nhập số điện thoại tại đây (Ví dụ: 097372xxxx)"
            name="login"
            type="tel"
            color="primary"
            v-mask="'##########'"
            v-model="phone"
            @keyup.enter="submit"
            :rules="phoneRules"
            outlined
            validate-on-blur
          />
          <div class="text-subtitle-1">Email liên hệ <span style="color: red">*</span></div>
          <v-text-field
            placeholder="VD: abcxyz@gmail.com"
            name="login"
            color="primary"
            v-model="parentEmail"
            :rules="[$rules.required, $rules.email]"
            outlined
          />
          <v-divider></v-divider>
          <div class="text-subtitle-1" style="margin-top: 22px;">Mật khẩu <span style="color: red">*</span></div>
          <v-text-field
            placeholder="PH tự tạo mật khẩu"
            v-model="password"
            color="primary"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            :rules="passwordRules"
            @click:append="showPassword = !showPassword"
            @keyup.enter="submit"
            outlined
            validate-on-blur
          />
          <div class="text-subtitle-1">Mật khẩu (nhắc lại) <span style="color: red">*</span></div>
          <v-text-field
            placeholder="Nhập mật khẩu tại đây"
            v-model="confirmPassword"
            :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showConfirmPassword ? 'text' : 'password'"
            :rules="confirmPasswordRules"
            @click:append="showConfirmPassword = !showConfirmPassword"
            @keyup.enter="submit"
            @keyup="$refs.form.validate()"
            color="primary"
            outlined
            validate-on-blur
          />
        </v-form>
        <!-- <div class="cf-turnstile" data-sitekey="0x4AAAAAAAQ-PRt09feV7Bnr"></div> -->
        <!-- <div class="cf-turnstile" data-sitekey="1x00000000000000000000AA"></div> -->
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions style="flex-direction: column;">
        <div style="width: 100%;">
          <v-btn
            depressed
            x-large
            color="primary"
            class="white--text text-subtitle-1 mt-4 text-none"
            style="width: 100%"
            :loading="loading"
            @click="submit"
            >Đăng ký</v-btn
          >
        </div>
        <div style="width: 100%;">
          <v-btn
            plain
            x-large
            color="primary"
            class="text-subtitle-1 font-weight-bold mt-2 text-none"
            style="width: 100%"
            @click="signin()"
            >Đã có tài khoản? Đăng nhập</v-btn
          >
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/* eslint-disable no-unused-vars */
import {mapActions, mapGetters} from 'vuex'
import highSchool from '../../assets/high_school.json'
import moment from 'moment'
import utils from '@/plugins/utils'
import provinces from '../../assets/vietnam_provinces.json'
import wards from '../../assets/vietnam_wards_v2.json'
import secondarySchool from '../../assets/secondary_school_v2.json'
import DobSplitInput from '../../modules/home/update-missing-dialog/DobSplitInput.vue'

export default {
  components: {DobSplitInput},
  watch: {
    signUpDialog: {
      immediate: true,
      handler(signUpDialog) {
        this.dialog = signUpDialog
      },
    },
    dialog: {
      handler(val) {
        if (val === true) {
          this.token = ''
          this.$nextTick(() => this.renderCF())
          this.enrollmentGrade = 'high'
        }
      },
      immediate: true,
    },
    selectedProvince(newVal) {
      if (newVal === this.otherProvinceText) {
        this.selectedWard = ''
        this.studentSchool = ''
      } else {
        this.otherWard = ''
        this.otherStudentSchool = ''
      }

      this.filteredWards = this.allWards.filter(ward => ward.province === newVal)
    },
    selectedWard() {
      this.filterSchools = this.allSchool.filter(
        school => school.province === this.selectedProvince && school.ward === this.selectedWard,
      )
    },
  },
  computed: {
    ...mapGetters('layout', ['signUpDialog']),
    ...mapGetters('auth', ['isAuthenticated', 'user']),
    allSchool() {
      return secondarySchool
    },
    expectOptions() {
      return highSchool
    },
    formattedDOB() {
      return this.dob ? moment(this.dob).format('DD/MM/YYYY') : ''
    },
  },
  data() {
    return {
      dialog: false,
      isValid: true,
      phone: '',
      parentName: '',
      studentName: '',
      identificationCode: '',
      address: '',
      studentSchool: '',
      otherStudentSchool: '',
      expectSchool: '',
      otherExpectSchool: '',
      parentEmail: '',
      englishScore: '',
      mathScore: '',
      dob: '',
      menu: false,
      token: '',
      confirmPassword: '',
      studentCode: '',
      enrollmentGrade: 'high',
      loading: false,
      showPassword: false,
      cfWidget: null,
      showConfirmPassword: false,
      password: '',
      phoneRules: [this.$rules.required, this.$rules.phone],
      passwordRules: [this.$rules.required, this.$rules.minLength(4)],
      confirmPasswordRules: [
        this.$rules.required,
        this.$rules.minLength(4),
        v => (v && v === this.password) || 'Mật khẩu (nhập lại) không trùng khớp với mật khẩu.',
      ],
      emailRules: [this.$rules.required, this.$rules.email],
      otherText: '+ NHẬP TRƯỜNG KHÁC',
      otherProvinceText: 'Tỉnh/Thành phố khác',
      provinces: provinces,
      selectedProvince: '',
      allWards: wards,
      selectedWard: '',
      filteredWards: [],
      filterSchools: [],
      otherWard: '',
      otherProvince: '',
    }
  },
  methods: {
    ...mapActions('auth', ['signUp']),
    ...mapActions('lead', ['createLead']),
    ...mapActions('layout', ['setSignUpDialog', 'setSignInDialog', 'setConfirmSignupDialog']),
    cancel() {
      this.$refs.form.reset()
      this.setSignUpDialog(false)
    },
    async submit() {
      const {isValid: isDobValid} = this.$refs['date-picker'].validate()
      if (!isDobValid) return this.$alert.error('Vui lòng nhập ngày sinh chuẩn')
      if (this.$refs.form.validate()) {
        const finalProvince =
          this.selectedProvince === this.otherProvinceText ? this.otherProvince : this.selectedProvince

        const finalward = this.selectedProvince === this.otherProvinceText ? this.otherWard : this.selectedWard

        const finalSchool =
          this.selectedProvince === this.otherProvinceText
            ? `(Khác) ${this.otherStudentSchool}`
            : this.studentSchool === this.otherText
            ? `(Khác) ${this.otherStudentSchool}`
            : this.studentSchool

        const emailData = {
          parentEmail: this.parentEmail,
          parentName: this.parentName,
          studentCode: this.studentCode,
          studentName: this.studentName,
          dob: this.formatDob(this.dob),
          province: finalProvince,
          ward: finalward,
          studentSchool: this.studentSchool === this.otherText ? this.otherStudentSchool : this.studentSchool,
          parentPhone: this.phone,
        }
        const userStudentData = {
          name: this.studentName,
          dob: this.formatDob(this.dob),
          province: finalProvince,
          ward: finalward,
          school: finalSchool,
          expectSchool: this.expectSchool === this.otherText ? `(Khác) ${this.otherExpectSchool}` : this.expectSchool,
          mathScore: this.mathScore,
          englishScore: this.englishScore,
          identificationCode: this.studentCode,
          address: this.address,
        }
        const studentData = {
          student: [
            {
              name: this.studentName,
              dob: this.formatDob(this.dob),
              province: this.selectedProvince,
              ward: this.selectedWard,
              school: finalSchool,
              mathScore: this.mathScore,
              englishScore: this.englishScore,
              identificationCode: this.studentCode,
              address: this.address,
            },
          ],
        }
        const leadData = {
          phone: this.phone,
          buyerName: this.parentName,
          email: this.parentEmail,
          createdByName: 'parent',
          expectSchool: this.expectSchool === this.otherText ? `(Khác) ${this.otherExpectSchool}` : this.expectSchool,
          studentExpectSchoolSearchField: utils.removeUnicode(this.expectSchool).toLowerCase(),
          studentSchoolSearchField: utils.removeUnicode(this.studentSchool).toLowerCase(),
          studentNameSearchField: utils.removeUnicode(this.studentName).toLowerCase(),
          type: ['hasAccount', 'noCV'],
          data: studentData,
        }
        try {
          this.loading = true
          const user = await this.signUp({
            username: this.studentCode,
            password: this.password,
            phone: this.phone,
            email: this.parentEmail,
            name: this.parentName,
            userStudentData,
            cfToken: this.token,
            enrollmentGrade: this.enrollmentGrade,
            emailData,
          })
          if (user) {
            await this.createLead({
              ...leadData,
            })
          }

          if (this.user && this.isAuthenticated) {
            this.$refs.form.reset()

            this.setSignUpDialog(false)
            this.setConfirmSignupDialog(true)
          } else {
            this.resetTurnstile()
          }
        } catch (error) {
          console.log('error=== ', error)
          if (error === 'Email already taken' || error === 'Email is already taken.') {
            this.$alert.error('Thông tin đã có trong hệ thống. Xin vui lòng kiểm tra lại!', {
              customClass: 'my-unique-alert',
            })
          } else {
            this.$alert.error('Tạo tài khoản thất bại!')
          }
          this.loading = false
        } finally {
          this.loading = false
        }
        this.loading = false
      } else {
        this.$nextTick(() => {
          const dialog = document.querySelector('.v-dialog.v-dialog--active')
          if (!dialog) return

          const dialogContent = dialog.querySelector('.v-card__text')
          if (!dialogContent) return

          const firstErrorInput = dialog.querySelector('.v-input.error--text')
          if (!firstErrorInput) return

          const top = firstErrorInput.getBoundingClientRect().top - dialogContent.getBoundingClientRect().top

          dialogContent.scrollTo({
            top: dialogContent.scrollTop + top - 32,
            behavior: 'smooth',
          })

          const input = firstErrorInput.querySelector('input, textarea')
          input && input.focus()
        })
      }
    },
    signin() {
      this.setSignInDialog(true)
      this.setSignUpDialog(false)
    },
    renderCF() {
      this.token = ''
      const cfContainer = document.querySelector('.cf-turnstile')
      if (cfContainer) {
        cfContainer.innerHTML = ''
      }

      if (window.turnstile) {
        window.turnstile.render('.cf-turnstile', {
          // sitekey: '1x00000000000000000000AA',
          sitekey: '0x4AAAAAAAQ-PRt09feV7Bnr',
          theme: 'light',
          callback: token => {
            if (token) {
              console.log(token)
              this.token = token
            }
          },
        })
      }
    },
    resetTurnstile() {
      const turnstileContainer = document.querySelector('.cf-turnstile')
      if (turnstileContainer) {
        turnstileContainer.innerHTML = ''
        this.renderCF()
      }
    },
    formatDob(dob) {
      if (!dob) return
      const [d, m, y] = dob.split('/')
      const formatedDob = [y, m, d].join('-')
      return formatedDob
    },
  },
}
/* eslint-enable no-unused-vars */
</script>

<style>
.v-messages {
  font-size: 16px !important;
}
.v-messages__message {
  line-height: 20px !important;
}

.enrollment-steps div {
  margin-left: 40px;
}

.v-messages__message {
  font-size: 16px;
}

.v-overlay {
  z-index: 200 !important;
}

.v-dialog__content {
  z-index: 201 !important;
}
</style>
